import { Expandable } from "@grindex-components/Accordion/Expandable.class";
import { $elementChild } from "@grindex-common/helpers/elements";
import { constants } from "@grindex-components/Accordion/Accordion.constants";
import { addListener, isInViewport } from "@grindex-common/helpers/domManipulation";
import FreeTextBlockDomElements from "./freeTextBlock.dom.elements";

function init($views) {
	const ATTRIBUTE_COUNTER = "started-counter";

	$views.forEach(($freeTextBlock) => {
		const dom = new FreeTextBlockDomElements($freeTextBlock);

		const $trigger = $elementChild($freeTextBlock, constants.SELECTOR_TRIGGER);
		const $accordionBody = $elementChild($freeTextBlock, constants.ELEMENT_ACCORDION_ITEM);
		const accordion = $accordionBody && $accordionBody.dataset.expandable === "true" ? new Expandable($accordionBody) : null;

		if (accordion) {
			addListener($trigger, "click", accordion.toggle.bind(accordion));
		}

		addListener(window, "scroll", function () {
			var counterElements = dom.getCounterElements();
			if (counterElements.length > 0) {
				if (isInViewport(counterElements[0])) {
					counterElements.forEach(($element) => {
						if (!$element.hasAttribute(ATTRIBUTE_COUNTER)) {
							const endValue = parseInt($element.innerText.replace(/[^0-9]/g, ""));
							$element.setAttribute(ATTRIBUTE_COUNTER, true);
							animateCounter($element, endValue, $element.innerText);
						}
					});
				}
			}
		});
	});

	function animateCounter(obj, end, objvalue) {
		let duration = 2000;
		let start = 0;

		let startTimestamp = null;
		const step = (timestamp) => {
			if (!startTimestamp) {
				startTimestamp = timestamp;
			}
			const progress = Math.min((timestamp - startTimestamp) / duration, 1);
			let num = Math.floor(progress * (end - start) + start);
			obj.innerHTML = num;

			if (num === end) {
				obj.innerHTML = objvalue;
			}

			if (progress < 1) {
				window.requestAnimationFrame(step);
			}
		};
		window.requestAnimationFrame(step);
	}
}

export default {
	view: "freeTextBlock",
	init,
};
